// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:18:48

export default {
  "id": "happy-town",
  "slug": "happy-town",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9e4d662e9fd0466d84316a652bd7fc9e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9e4d662e9fd0466d84316a652bd7fc9e/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Happy Town",
      "description": "In Happy Town you have to lead your own city and make its inhabitants happy!\n\nBecoming the mayor of your happy city is very simple! Combine items, upgrade buildings, complete tasks for residents, communicate with them, expand and enjoy a vibrant style and soundtrack. Residents are waiting for you!",
      "instructions": "The goal of the game is to become a successful mayor, develop your city by improving buildings, completing tasks for residents, communicating with them and expanding the territory to make the city happy and prosperous.\n\nControl: left mouse button/touch.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "city",
        "connection",
        "cute",
        "story"
      ]
    },
    "zh-CN": {
      "title": "快乐镇",
      "description": "在快乐小镇，你需要领导自己的城市，让它的人民幸福！\n\n成为快乐城市的市长非常简单！组合物品，升级建筑，完成居民的任务，与他们沟通，扩展并享受充满活力的风格和配乐。居民们正在等待你！",
      "instructions": "游戏目标是成为一名成功的市长，通过改善建筑、完成居民的任务、与他们沟通以及扩大领土，使城市幸福繁荣。\n\n控制方式：左鼠标按钮/触摸。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "城市",
        "连接",
        "可爱",
        "故事"
      ]
    },
    "zh-TW": {
      "title": "幸福鎮",
      "description": "在快樂城，你需要領導自己的城市並讓居民快樂！\n\n成為快樂城市的市長非常簡單！合併物品、升級建築、完成居民的任務、與他們溝通、擴張並享受豐富的風格和音樂。居民們正在等待你！",
      "instructions": "遊戲的目標是成為一位成功的市長，透過改善建築物、完成居民的任務、与他们溝通並擴張領土，使城市幸福繁榮。\n\n控制方式：左鍵/觸控。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1 玩家",
        "城市",
        "連接",
        "可愛",
        "故事"
      ]
    },
    "zh-HK": {
      "title": "幸福城",
      "description": "在快樂城，你要領導自己的城市，並讓其居民快樂！\n\n成為快樂城市的市長非常簡單！合併物品、升級建築、完成居民的任務、與他們溝通，擴張並享受生動的風格和音樂。居民們在等待你！",
      "instructions": "遊戲的目標是成為一位成功的市長，透過改善建築、完成居民任務、與他們溝通和擴張領地，讓城市快樂繁榮。\n\n控制方式：左鍵/觸控。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "城市",
        "連線",
        "可愛",
        "故事"
      ]
    },
    "ja": {
      "title": "ハッピー・タウン",
      "description": "Happy Townであなた自身の街を指揮し、住民を幸せにすることを目指してください！\n\n幸せな街の市長になることは非常に簡単です！アイテムを組み合わせ、建物をアップグレードし、住民のタスクを完了し、彼らとコミュニケーションを取り、拡張し、活気あるスタイルとサウンドトラックを楽しみましょう。住民たちはあなたを待っています！",
      "instructions": "ゲームの目標は市長として成功し、建物を改善し、住民のタスクを完了し、彼らとコミュニケーションを取り、地域を拡張することで都市を幸せで豊かなものにするすることです。\n\nコントロール：左マウスボタン/タッチ。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "都市",
        "接続",
        "可愛い",
        "物語"
      ]
    },
    "ko": {
      "title": "행복마을",
      "description": "Happy Town에서는 자신의 도시를 이끌고 주민들을 행복하게 만들어야 합니다!\n\n행복한 도시의 시장이 되는 것은 매우 간단합니다! 아이템을 조합하고 건물을 업그레이드하고 주민들의 임무를 완료하며, 그들과 소통하고 확장하며 활기찬 스타일과 사운드트랙을 즐겨보세요. 주민들은 당신을 기다리고 있습니다!",
      "instructions": "게임의 목표는 성공적인 시장이 되는 것입니다. 건물을 개선하고 주민들에게 임무를 완료하며, 그들과 소통하며 토지를 확장하여 도시를 행복하고 번영하게 만드세요.\n\n제어: 왼쪽 마우스 버튼/터치.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "도시",
        "연결",
        "귀엽다",
        "이야기"
      ]
    },
    "fr": {
      "title": "Belle-Ville",
      "description": "Dans Happy Town, vous devez diriger votre propre ville et rendre ses habitants heureux !\n\nDevenir maire de votre ville heureuse est très simple ! Combinez des objets, améliorez les bâtiments, accomplissez des tâches pour les résidents, communiquez avec eux, étendez-vous et profitez d'un style et d'une bande originale dynamiques. Les résidents vous attendent !",
      "instructions": "L'objectif du jeu est de devenir un maire réussi, de développer votre ville en améliorant les bâtiments, en accomplissant des tâches pour les résidents, en communiquant avec eux et en élargissant le territoire pour rendre la ville heureuse et prospère.\n\nContrôle : bouton gauche de la souris/touche.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "ville",
        "connexion",
        "mignon",
        "histoire"
      ]
    }
  }
};
